<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>首页</el-breadcrumb-item>
      <el-breadcrumb-item>赛务管理</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/raceManagement/team_management/team_race_management' }">团体赛赛务管理 </el-breadcrumb-item>
      <el-breadcrumb-item>团体赛抽签</el-breadcrumb-item>
    </el-breadcrumb>
    <el-page-header @back="goBack"></el-page-header>
    <el-card style="margin-top: 15px">
      <el-row class="title_row">
        <el-col>
          <span class="title_class">团体赛抽签
            <el-button
              type="primary"
              size="small"
              plain
              style="margin-left: 20px;"
              @click="copyLink"
              >复制大屏链接</el-button
          >
          </span>
        </el-col>
      </el-row>
      <el-form
          :model="queryForm"
          class="filter_Form"
          label-width="60px"
          ref="queryFormRef"
      >
          <el-row>
              <el-col :span="5">
                  <el-form-item label="赛季" prop="season">
                      <el-select
                          placeholder="请选择类型"
                          style="width: 100%"
                          v-model="queryForm.season"
                      >
                          <el-option
                              v-for="item in dict_season"
                              :key="item.dictCode"
                              :label="item.dictLabel"
                              :value="item.dictValue"
                          ></el-option>
                      </el-select> </el-form-item
              ></el-col>
              <el-col :span="5">
                  <el-form-item label="组别" prop="level">
                      <el-select
                          placeholder="请选择"
                          style="width: 100%"
                          v-model="queryForm.level"
                          @change="levelChange"
                      >
                          <el-option
                              v-for="(item, i) in levels"
                              :key="i"
                              :label="item"
                              :value="i"
                          ></el-option>
                      </el-select>
                  </el-form-item>
              </el-col>
              <el-col :span="14" v-if="groupList.length || teamList.length">
                <div class="set">
                  <span class="level">小组数：</span>
                  <el-input-number v-model="groupNum" :min="1" :max="10" @change="numChange" class="mr"></el-input-number>
                  <span class="level">每组队伍数：</span>
                  <el-input-number v-model="teamNum" :min="1" :max="5" @change="numChange"></el-input-number>
                  <div class="t-r">
                    <el-button type="primary" @click="saveAll">保存抽签结果</el-button>
                  </div>
                </div>
              </el-col>
          </el-row>
      </el-form>
      <el-row v-if="groupList.length || teamList.length">
        <el-col :span="16">
          <div class="title" @click="getInfo">抽签结果：<i class="el-icon-refresh"></i></div>
          <div class="panel">
            <div class="group" v-for="(group, i) in groupList" :key="i">
              <div class="flex">
                <span class="index">{{ group.group }}</span>
                <div class="item" v-for="(item, j) in group.teamList" :key="j">
                  <el-input v-model="item.str" type="textarea" :rows="4" @change="inputChange"></el-input>
                </div>
              </div>
            </div>
            <div class="btn" v-if="groupList.length && id"><el-button type="danger" plain @click="delFn">清空抽签结果</el-button></div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="title" @click="getTeamList">待抽签战队({{ teamList.length }})：<i class="el-icon-refresh"></i></div>
          <div class="panel">
            <div class="row" v-for="(item, i) in teamList" :key="i">
              <div class="col col1">{{ item.name }}</div>
              <div class="col col1">{{ item.schoolName }}</div>
              <div class="col col2"><el-button type="primary" size="mini" plain @click="copy(item)">复制</el-button></div>
            </div>
          </div>
        </el-col>
      </el-row>
      <div class="" v-else>
        <el-empty description="暂无待参赛战队"></el-empty>
      </div>
    </el-card>
  </div>
</template>

<script>

export default {
  data () {
    return {
      dict_season: this.$userInfo.getDataList(this, 't_season', this.$store.state.flag).then(value => { this.dict_season = value }),
      levels: [
        '小学组', '初中组', '高中组'
      ],
      activityType: this.$chnEngStatusCode.itsoActivityType,
      queryForm: {
        level: 0,
        season: this.$chnEngStatusCode.defaultSeason,
        raceSchedule: this.$route.query.raceSchedule
      },
      groupNum: 0, // 小组数
      teamNum: 4, // 小组内队伍数
      input: '',
      teamList: [],
      groupList: [],
      id: ''
    }
  },
  created () {
    this.getTeamList()
  },
  methods: {
    goBack () {
      this.$router.back()
    },
    getInfo () {
      this.$http.get('/itsoDrawLots/getFormInfo', { params: this.queryForm }).then(res => {
        if (res.code === 200) {
          if (res.data) {
            this.groupList = JSON.parse(res.data.formText)
            this.groupNum = res.data.groupNum
            this.teamNum = res.data.teamNum
            this.id = res.data.id
            this.refreshData(res.data)
            if (!this.groupList.length) {
              this.initTeamForm()
            }
          } else {
            this.initTeamForm()
          }
        }
      })
    },
    getTeamList () {
      this.$http.get('/itsoDrawLots/getTeamList', { params: { ...this.queryForm, ...{ activityType: this.activityType } } }).then(res => {
        if (res.code === 200) {
          const total = res.data.length
          this.groupNum = Math.ceil(total / this.teamNum)
          this.teamList = res.data
          this.getInfo()
        }
      })
    },
    // 无抽签数据时，按每组4个队伍，初始化一套表格
    initTeamForm () {
      const groupList = []
      for (let i = 1; i <= this.groupNum; i++) {
        const teamList = [] // 每次循环创建新的 teamList
        for (let j = 1; j <= this.teamNum; j++) {
          teamList.push({
            // teamName: '',
            // schoolName: '',
            str: ''
          })
        }
        groupList.push({
          group: String.fromCharCode(64 + i),
          teamList // 独立的 teamList
        })
      }
      this.groupList = groupList
    },

    // 刷新待抽签战队
    refreshData () {
      // 处理数组内数据
      this.groupList.forEach(group => {
        group.teamList.forEach(item => {
          if (item) {
            // item.teamName = item.str.split('\n')[0]
            // item.schoolName = item.str.split('\n')[1]
            // item.img = item.str.split('\n')[2]
            this.teamList = this.teamList.filter(teamItem => teamItem.name !== item.str.split('\n')[0])
          }
        })
      })
    },

    // 保存抽签结果
    saveAll () {
      this.refreshData()
      const formText = JSON.stringify(this.groupList)
      this.$http.post('/itsoDrawLots/save', { ...{ formText, groupNum: this.groupNum, teamNum: this.teamNum }, ...this.queryForm }).then(res => {
        if (res.code === 200) {
          this.id = res.data
        }
      })
    },

    inputChange () {
      this.refreshData()
    },
    numChange () {
      this.initTeamForm()
    },
    levelChange () {
      this.id = ''
      this.teamNum = 4
      this.teamList = []
      this.groupNum = 0
      this.groupList = []
      this.getTeamList()
    },
    copy (item) {
      const textToCopy = `${item.name}\n${item.schoolName}\n${item.clubLogourl}`
      this.copyToClipboard(textToCopy)
      // try {
      //   navigator.clipboard.writeText(textToCopy)
      //   this.$message.success('复制成功')
      // } catch (err) {
      //   this.$message.warning('复制失败:' + err)
      // }
    },
    copyToClipboard (text) {
      return new Promise((resolve, reject) => {
        try {
          if (navigator.clipboard) {
            navigator.clipboard.writeText(text).then(resolve).catch(reject)
            this.$message.success('复制成功')
          } else {
            const textarea = document.createElement('textarea')
            textarea.value = text
            textarea.style.position = 'fixed' // 避免滚动
            document.body.appendChild(textarea)
            textarea.select()
            try {
              const successful = document.execCommand('copy')
              if (successful) {
                this.$message.success('复制成功')
                resolve()
              } else {
                this.$message.warning('复制失败')
                reject(new Error('Copy failed'))
              }
            } finally {
              document.body.removeChild(textarea)
            }
          }
        } catch (err) {
          reject(err)
        }
      })
    },
    delFn () {
      if (this.id) {
        this.$http.post('/itsoDrawLots/del', { id: this.id }).then(res => {
          if (res.code === 200) {
            this.levelChange()
            this.id = ''
          }
        })
      } else {
        this.levelChange()
      }
    },
    copyLink () {
      const text = `${window.location.origin}/#/itsoDraw`
      this.copyToClipboard(text)
    }
  }
}
</script>

<style lang="less" scoped>
.set{
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  .level{
    width: 90px;
    text-align: right;
    color: #606266;
    font-size: 14px;
  }
  .mr{
    margin-right: 20px;
  }
}
.t-r{
  flex: 1;
  text-align: right;
}
.flex{
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.index{
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  color: #409eff;
  width: 18px;
  text-align: center;
  margin-right: 6px;
}
.group{
  background-color: #ecf5ff;
  padding: 16px 10px;
  margin: 0 4px 20px;
}
.item{
  flex: 1;
  min-width: 0;
  padding: 0 4px;
  box-sizing: border-box;
}
.title{
  color: #4096ff;
  background-color: #ecf5ff;
  padding: 4px 10px;
  font-size: 14px;
  margin: 4px;
  cursor: pointer;
}
.row{
  border-bottom: 1px solid #ebebeb;
  display: flex;
  align-items: center;
  padding: 4px;
  margin: 0 4px;
  &:hover{
    background-color: #ecf5ff;
  }
  .col{
    color: #606266;
    font-size: 14px;
  }
  .col1{
    width: 43%;
  }
  .col2{
    width: 10%;
    text-align: right;
  }
}
.panel{
  height: calc(100vh - 346px);
  overflow-y: auto;
  overflow-x: hidden;
}
.btn{
  text-align: center;
}
</style>
